import React from 'react'
import Typewriter from "typewriter-effect"
const About = () => {
  return (
    <div name="About" 
         className='w-full h-screen bg- bg-slate-800 text-slate-200 pt-24 pb-24'
         >
          <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-fit' data-aos="flip-right" data-aos-duration="1000">
              <div className="pb-8">
                <p className='text-4xl font-bold inline border-b-4 border-amber-500'>
                  About Me
                </p>
              </div>
              <p className='text-3xl font-bold'> 
                <Typewriter
                options={{
                strings: [
                "I'm Supriyo Samanta"
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 100,
                  }}
                  /> 
                </p>
                <br/>
                <br/>
                <p className='text-xl'>I have expertise in the MERN stack. With a proactive approach, 
                I am interested in exploring and dedicated to serving my best with my knowledge and skill sets to build dynamic websites for various business perspectives. I spent my leisure hours watching movies/series and surfing YouTube. Right now, I'm also 
                trying a hand at Redux and TypeScript. I love to learn and explore new arenas. </p>
          </div>

    </div>
  )
}

export default About